import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import api from '../../utils/api';
import { toast } from 'react-toastify';

export const getAllVendorThunk = createAsyncThunk(
  'vendor/getAllvendor',
  async (config, { rejectWithValue }) => {
    try {
      const response = await api.getAllVendor(config);
      console.log("res",response);
      
      return response.data;
    } catch (error) {
      console.log(error);

    }
  }
);


export const getVendorDetailsThunk = createAsyncThunk(
  'vendor/getvendordetails',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.getVendorDetails(id);

      return response.data?.data;
    } catch (error) {
      console.log(error);

    }
  }
);



export const vendorrejectOrAproveThunk = createAsyncThunk(
  'vendorreject/vendorrejectoraprove',
  async (data, { rejectWithValue, dispatch }) => {

    try {
      const response = await api.rejectOrAproveVendor(data);
      toast.success(response.data?.data?.message || 'success')
      dispatch(setvendorRefresh())
    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message)
    }
  }
);


export const deletevendorThunk = createAsyncThunk(
  'deletevendor/deletevendorThunk',
  async (data, { rejectWithValue, dispatch }) => {

    try {
      const response = await api.deleteVendor(data?.id ?? data, data?.password);
      toast.success(response.data?.data?.message || 'success')
      dispatch(setvendorRefresh())
    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message || 'something went wrong')
    }
  }
);



export const addVendorThunk = createAsyncThunk(
  'vendor/addvendor',
  async (data, { rejectWithValue, dispatch }) => {

    try {
      const response = await api.addVendor(data);
      toast.success(response.data?.data?.message || 'success')
      return response.status
    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message)
    }
  }
);



export const editVendorThunk = createAsyncThunk(
  'vendor/editVendorThunk',
  async (data, { rejectWithValue, dispatch }) => {

    try {
      const response = await api.updateVendor(data);
      toast.success(response.data?.data?.message || 'success')
      return response.status
    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message)
    }
  }
);


export const exportVendorThunk = createAsyncThunk(
  'vendor/exportvendor',
  async (config, { rejectWithValue }) => {
    try {
      const response = await api.exportVendor(config);
      return response.data;
    } catch (error) {
      console.log(error);

    }
  }
);

// Slice for categories
const vendorSlice = createSlice({
  name: 'vendor',
  initialState: {
    vendor: [],
    vendorDetails: {},
    editvendor: null,
    loading: false,
    error: null,
    refresh: false,
    statusLoading: false,
    exportLoading: false,
    page:1
  },
  reducers: {
    setvendorRefresh: (state, action) => {
      state.refresh = !state.refresh
    },
    setvendorEdit: (state, action) => {
      state.editvendor = action.payload;
    },
    setVendorPage:(state,action)=>{
        state.page = action.payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllVendorThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllVendorThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.vendor = action.payload;
      })
      .addCase(getAllVendorThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      //getdetails
      .addCase(getVendorDetailsThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getVendorDetailsThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.vendorDetails = action.payload;
      })
      .addCase(getVendorDetailsThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      //rejectoraprove

      .addCase(vendorrejectOrAproveThunk.pending, (state) => {
        state.statusLoading = true;
        state.error = null;
      })
      .addCase(vendorrejectOrAproveThunk.fulfilled, (state, action) => {
        state.statusLoading = false;

      })
      .addCase(vendorrejectOrAproveThunk.rejected, (state, action) => {
        state.statusLoading = false;
        state.error = action.payload;
      })

      //export vendor
      .addCase(exportVendorThunk.pending, (state) => {
        state.exportLoading = true;
      })
      .addCase(exportVendorThunk.fulfilled, (state, action) => {
        state.exportLoading = false;
      })
      .addCase(exportVendorThunk.rejected, (state, action) => {
        state.exportLoading = false;
      })

  },
});

export const { setvendorEdit, setvendorRefresh,setVendorPage } = vendorSlice.actions

export default vendorSlice.reducer;

